import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'copart-copart-ng-components',
  template: `
    <p>
      copart-ng-components works!
    </p>
  `,
  styles: []
})
export class CopartNgComponentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
